/**
 * Which docked-phone placement to render. Two variants are built so they can be
 * compared live; flip the default below (or set `VITE_PHONE_DOCK_VARIANT=slide-in`
 * in the Vercel project env) and redeploy to switch.
 *
 *  - 'sidebar'  : a slim bar at the bottom of the sidebar, expands inline.
 *  - 'slide-in' : a fixed launcher button + slide-in panel (drawer pattern).
 *
 * Default: 'sidebar'. Final choice is Willem's after a live demo (plan Step 13).
 */

export type PhoneDockVariant = 'sidebar' | 'slide-in';

export const PHONE_DOCK_VARIANT: PhoneDockVariant =
  (import.meta.env.VITE_PHONE_DOCK_VARIANT as string) === 'slide-in' ? 'slide-in' : 'sidebar';
